import * as TYPES from './mutationTypes'

export default {
  [TYPES.RUST_PAGE_TAB](state, payload) {
    Object.assign(state, {
      rustTab: payload.params
    })
  },

  [TYPES.SOLIDITY_PAGE_TAB](state, payload) {
    Object.assign(state, {
      solidityTab: payload.params
    })
  }
}
